import { Modal, ModalRootProps } from '@mantine/core';
import clsx from 'clsx';
import { useUnit } from 'effector-react';
import { forwardRef } from 'react';
import { ModalFormModel } from 'shared/lib';

export type ModalFormRootProps = Omit<ModalRootProps, 'opened' | 'onClose' | 'onExitTransitionEnd'>;

export const createModalFormRoot = <TModalData, TFormValues extends Record<string, unknown>>(
	modalFormModel: ModalFormModel<TModalData, TFormValues>,
) => {
	const ModalFormRoot = forwardRef<HTMLDivElement, ModalFormRootProps>(
		({ className, children, centered = true, ...props }, ref) => {
			const { active, disable } = useUnit(modalFormModel.switcher);
			const exited = useUnit(modalFormModel.modalClosed);

			return (
				<Modal.Root
					ref={ref}
					opened={active}
					centered={centered}
					className={clsx('modal-form-root', className)}
					onClose={disable}
					onExitTransitionEnd={exited}
					{...props}
				>
					{children}
				</Modal.Root>
			);
		},
	);

	return ModalFormRoot;
};
